import React from 'react';




const Loading = () => {
    return ( 
        <div className='absolute flex justify-center items-center h-full w-full z-50 top-0 left-0 bg-black'>
            <h1 className='text-red-500 text-[60px] md:text-[100px] text-center m-auto animated-word'>NEWS <span className='text-white'>CAST</span></h1>
        </div>
     );
}
 
export default Loading;
